import { lazy } from 'react'
import { useIntersectionObserver } from 'usehooks-ts'

const LazyLottie = lazy(() => import('./lottie'))
import ShieldLoader from '../ui/shield-loader'
import type { LottieProps } from './lottie'
import { useInspectorProps } from '@/utils/live-preview'
import { cx } from '@/utils/strings'

export default function Lottie(props: LottieProps) {
  const pageInspectorProps = useInspectorProps({
    entryId: props.entryId,
    restrictedTypes: ['pages'],
  })
  const src = props.animationData || props.lottieFile?.fields?.file?.url || (props.lottieFile as any)?.file?.url
  const width = props.metadata?.width
  const height = props.metadata?.height
  const mobileWidth = props.metadata?.mobile?.width
  const mobileHeight = props.metadata?.mobile?.height

  const { isIntersecting, ref } = useIntersectionObserver({
    rootMargin: '200px',
    freezeOnceVisible: true,
  })
  const { isIntersecting: isMobileIntersecting, ref: mobileRef } = useIntersectionObserver({
    rootMargin: '200px',
    freezeOnceVisible: true,
  })

  if (!src) return null

  return (
    <div {...pageInspectorProps({ fieldId: 'autoplayType' })}>
      <div
        ref={ref}
        className={cx(props.mobileLottieFile && 'hidden md:block')}
        style={{ aspectRatio: width && height ? `${width} / ${height}` : undefined }}
      >
        {isIntersecting ? (
          <LazyLottie {...props} />
        ) : (
          <div className="flex items-center justify-center h-full w-full">
            <ShieldLoader />
          </div>
        )}
      </div>
      {props.mobileLottieFile && (
        <div
          ref={mobileRef}
          className="md:hidden"
          style={{ aspectRatio: mobileWidth && mobileHeight ? `${mobileWidth} / ${mobileHeight}` : undefined }}
        >
          {isMobileIntersecting ? (
            <LazyLottie {...props} lottieFile={props.mobileLottieFile} metadata={props.metadata?.mobile || {}} />
          ) : (
            <div className="flex items-center justify-center h-full w-full">
              <ShieldLoader />
            </div>
          )}
        </div>
      )}
    </div>
  )
}
